/**
 * The caller's OWN workspaces + "Aggiungi workspace" (ADR-0076 fetta 5).
 *
 * The principal is the operator's central identity (ADR-0077), never the Organizzazione — so this
 * lists exactly the workspaces they can already enter. A local-only account gets a 422
 * (`organization:requires_central_account`), which the UI renders as an honest note rather
 * than an empty list.
 */
import type { BillingPayload } from "@/lib/billingProfile";
import { api } from "./api";

export interface OrgWorkspace {
  tenant_id: string;
  slug: string;
  name: string;
  status: string;
  plan_name: string | null;
  subscription_status: string | null;
  /** True for the workspace serving this request — no switch link for it. */
  current: boolean;
  url: string;
}

export interface CreateWorkspaceInput {
  slug: string;
  name?: string | null;
  /** REQUIRED (ADR-0079) — a workspace with no plan is a workspace nobody pays for. */
  plan_key: string;
  billing_period?: "month" | "year";
  /** REQUIRED in practice: the purchase gate (`assert_billing_complete`) refuses a
   *  checkout with no invoiceable profile, so a create without this 422s
   *  `billing:incomplete` — each workspace carries its OWN profile (ADR-0076/0080). */
  billing?: BillingPayload;
}

export const organizationApi = {
  list: () => api.get<{ items: OrgWorkspace[] }>("/organization/workspaces").then((r) => r.items),
  /**
   * BUY another workspace for this workspace's organization. It returns a Stripe Checkout
   * URL, not a workspace: the tenant is provisioned by the payment webhook, and the card
   * charged is the ORGANIZATION's saved one.
   */
  create: (body: CreateWorkspaceInput) =>
    api.post<{ slug: string; checkout_url: string; token: string }>(
      "/organization/workspaces",
      body,
    ),
};
